import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from 'jquery';
import {IMAGE_ROOT} from "../api-config";
import {withTranslation} from 'react-i18next';
import i18n from '../i18n';

class forgot_password_msg extends Component {

    constructor(props) {
        super(props);

        this.state = {
            windowHeight: 0,
            redirect:false,
        };
        this.updateState = this.updateState.bind(this);
    };

    updateState(e) {
        this.setState({});
    }

    componentWillMount() {
        var height = $(window).height();

        this.setState({windowHeight: height});


        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });
    }

    componentDidMount() {

        document.title = "Forgot Password - " + localStorage.getItem("store_name") + " - Order Anywhere";

        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }

        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }

        var dis=this;
        $('#signUpBtn').click(function (){
           dis.setState({redirect:true});

        });

        $('#home').css('background', 'none');
    }

    render() {

        const {t} = this.props;
        if (this.state.redirect) {
            return <Redirect to="/login"/>;
        }
        return (
            <div>
                <header className="fixedHeader">
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                        <Link to="/login"></Link>
                        <h2 className="text-center"><strong>{t('forgot_password')}</strong></h2>
                    </div>
                </header>
                <div className="mt-white checkout h-100 "
                     style={{position: "fixed", width: "100%", height: "100vh", overflowY: "scroll"}}>
                    <div className="simple-box h-100 m-b-0 bp-0 p-b-35 bkg-white middleContent"
                         style={{padding: "0px", paddingBottom: "150px"}}>
                        <div className="form-box w-75 div-center">
                            <div className="header-title">
                                <h2 className="text-center font-size-20 m-0">{t('reset_link_sent')}</h2>
                                <div className="border-bottom"></div>
                            </div>
                            <div className="panel-body">
                                {t('reset_link_inst')}
                            </div>

                            <div className="form-group m-t-30 btn-red m-b-30">
                                <input type="submit" name="signUpBtn" id="signUpBtn" value={t('login')}/>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default withRouter(withTranslation()(forgot_password_msg));


// WEBPACK FOOTER //
// ./src/view_components/forgot_password_msg.js